import { app } from "../../service/serviceLMS";
import { GET_QUIZ, CREATE_QUIZ, UPDATE_QUIZ,GET_QUESTIONS_QUIZ, CREATE_QUESTION, UPDATE_QUESTION, DELETE_QUESTION, GET_QUIZ_ADMIN } from "../URLs";


export const fetchQuizByCourse = async (courseId) => {
  try {
    const response = await app.get(GET_QUIZ(courseId));
    return response.data?.data?.[0] || null;
  } catch (error) {
    console.error("API Error fetching quiz:", error);
    throw new Error(error?.response?.data?.message || "Failed to fetch quiz");
  }
};

export const fetchQuizByCourseAdmin = async (courseId) => {
  try {
    const response = await app.get(GET_QUIZ_ADMIN(courseId));
    return response?.data?.data || null;
  } catch (error) {
    console.error("API Error fetching quiz:", error);
    throw new Error(error?.response?.data?.message || "Failed to fetch quiz");
  }
}
 
export const createQuiz = async (payload) => {
  try {
    const response = await app.post(CREATE_QUIZ, payload);
    return response.data?.data || null;
  } catch (error) {
    console.error("API Error creating quiz:", error);
    throw new Error(error?.response?.data?.message || "Failed to create quiz");
  }
};
 
export const updateQuiz = async (quizId, payload) => {
  try {
    const response = await app.put(UPDATE_QUIZ(quizId), payload);
    return response.data;
  } catch (error) {
    console.error("API Error updating quiz:", error);
    throw new Error(error?.response?.data?.message || "Failed to update quiz");
  }
};
 
 
export const fetchQuestionsByQuiz = async (quizId) => {
  try {
    const response = await app.get(GET_QUESTIONS_QUIZ(quizId));
    return response.data?.data || [];
  } catch (error) {
    if (error?.response?.status === 404) return [];
    console.error("API Error fetching questions:", error);
    throw new Error(error?.response?.data?.message || "Failed to fetch questions");
  }
};
 
export const createQuestion = async (payload) => {
  try {
    const response = await app.post(CREATE_QUESTION, payload);
    return response.data;
  } catch (error) {
    console.error("API Error creating question:", error);
    throw new Error(error?.response?.data?.message || "Failed to create question");
  }
};
 
export const updateQuestion = async (questionId, payload) => {
  try {
    const response = await app.put(UPDATE_QUESTION(questionId), payload);
    return response.data;
  } catch (error) {
    console.error("API Error updating question:", error);
    throw new Error(error?.response?.data?.message || "Failed to update question");
  }
};
 
export const deleteQuizQuestion = async (questionId) => {
  try {
    const response = await app.delete(DELETE_QUESTION(questionId));
    return response.data;
  } catch (error) {
    console.error("API Error deleting question:", error);
    throw new Error(error?.response?.data?.message || "Failed to delete question");
  }
};